import { FC } from 'react';

import styled from '@emotion/styled';
import { ChildCandidate, ForWhom } from 'store/candidate/types';
import { formatDate } from 'core';
import { Tooltip } from 'react-tooltip';

import { BcRadio, Divider, Quote } from '@britishcouncil/react-solas-ors3';
import { getUsername } from 'core/getUsername';

export const ChooseTestTaker: FC<{
  forWhom?: ForWhom;
  candidateId: number | null;
  children: ChildCandidate[];
  maxChildCandidates?: number;
  onChange: (forWhom: ForWhom, candidateId: number | null) => void;
}> = ({ forWhom, candidateId, children, maxChildCandidates = 0, onChange }) => {
  return (
    <>
      <Tooltip id={`candidate-choose-info-tolltip-myself`} place="left" content="I am the Candidate" />
      <Tooltip
        id={`candidate-choose-info-tolltip-child`}
        place="left"
        content="I am booking on behalf of a child candidate under the age of 18 years"
      />
      <h2>Who you will register the exam for?</h2>
      <StyledTakerContainer>
        <div data-tooltip-id="candidate-choose-info-tolltip-myself">
          <BcRadio value={forWhom} checkedValue={ForWhom.Myself} onChange={(val) => onChange(ForWhom.Myself, null)}>
            Myself
          </BcRadio>
        </div>
        {children.map((candidate, i) => (
          <BcRadio
            value={candidateId || ''}
            checkedValue={candidate.id}
            key={i}
            onChange={(val) => onChange(ForWhom.CurrentChild, candidate.id)}
          >
            {`${getUsername(candidate)}`}
            <SubTitle>{`Date of birth: ${formatDate(candidate.dateOfBirth)}`}</SubTitle>
            {
              candidate.isMinorToAdultMigrationInProgress && (
                <Quote title="" intent="success">
                  Migration in progress
                </Quote>
              )
            }
          </BcRadio>
        ))}
        {maxChildCandidates > children.length && (
          <div data-tooltip-id="candidate-choose-info-tolltip-child">
            <BcRadio
              value={forWhom}
              checkedValue={ForWhom.NewChild}
              onChange={(val) => onChange(ForWhom.NewChild, null)}
            >
              Minor (under 18 years)
            </BcRadio>
          </div>
        )}
      </StyledTakerContainer >
      {forWhom === ForWhom.NewChild && (
        <Quote title="" intent="warning">
          If your child is 18 or over, please ask them to register for themselves.
        </Quote>
      )
      }
      <Divider />
    </>
  );
};

const StyledTakerContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SubTitle = styled.div`
  font-size: 0.8em;
  line-height: 1.2em;
`;
